import { NgModule } from "@angular/core";
import { RequestsResolver } from "./requests/requests.resolver";

@NgModule({
    declarations: [

    ],
    imports: [
    ],
    providers: [
        RequestsResolver
    ]
})
export class ResolverModule { }